module.exports = __webpack_public_path__ + "static/img/image 77.83100787.png";